import { usePermissionCheck } from '@percent/partner-dashboard/common/hooks/useAllow/usePermissionCheck'
import { POSTHOG_FEATURE_FLAGS, useAuthState, usePostHogFeatureFlag } from '@percent/partner-dashboard/common/hooks'
import { selectScopes } from '@percent/partner-dashboard/context/auth'
import { canViewReports } from './reportsConfig'
import { useCanViewInsightsReports } from './useCanViewInsightsReports'

export const useCanViewGrantsInsightsReports = (): boolean => {
  // enabled per account
  const canViewInsightsReports = useCanViewInsightsReports()
  // enabled per partner
  const grantsInsightsReportsFeatureFlag = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.PD_INSIGHTS_REPORTS_GRANTS)
  const { partner } = useAuthState()
  const { userCan } = usePermissionCheck()

  return (
    canViewInsightsReports ||
    canViewReports({
      insightsReportsFeatureFlag: grantsInsightsReportsFeatureFlag,
      scopes: selectScopes(partner?.scopes),
      userCan
    })
  )
}
